import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { normalizePath } from './App';

// Le HTML de chaque page publique est prerendu au build (scripts/prerender.js) :
// si la page servie correspond à l'URL courante, on hydrate le balisage existant
// (LCP, SEO) ; sinon (espace utilisateur servi via index.html) on rend à neuf.
document.documentElement.classList.add('js');
const container = document.getElementById('root');
const prerenderedRoute = container.getAttribute('data-route');
if (container.getAttribute('data-prerendered') === '1' && prerenderedRoute === normalizePath(window.location.pathname)) {
  ReactDOM.hydrateRoot(container, <App />);
} else {
  container.innerHTML = '';
  ReactDOM.createRoot(container).render(<App />);
}
